import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionGrantRewardsCollect } from "../grant-rewards/actionGrantRewards";
import { actionStoreBuyPackage } from "./actionStore";
import { RewardStoreProfilePictures } from "./RewardStoreProfilePictures";
import { RewardStoreResources } from "./RewardStoreResources";
var _DialogCollectRewardStore = function (_a) {
    var rewards = _a.rewards, onCollect = _a.onCollect, onCollectAndRepeat = _a.onCollectAndRepeat, cost = _a.cost, packageId = _a.packageId;
    var isPictureReward = rewards.profilePictureRewards.length !== 0;
    var rewardsList = isPictureReward ? (React.createElement(RewardStoreProfilePictures, { rewards: rewards })) : (React.createElement(RewardStoreResources, { rewards: rewards, backgroundClassName: "chest-rewards-background" }));
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.hooray, className: IdStyles.ModalBackgroundLevelUp, onClose: onCollect },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            rewardsList,
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonPrimary, { onClick: function () { return onCollectAndRepeat(packageId, cost); } },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collectAndAgain })),
                React.createElement(ButtonPrimary, { onClick: onCollect },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect }))))));
};
var mapState = function (state) {
    var _a = state.storeInfo.package.balancing, cost = _a.cost, id = _a.id;
    var actualCost = (cost || []).map(function (_a) {
        var amount = _a.amount, resourceId = _a.resourceId;
        return ({
            amount: Long.fromNumber(amount),
            typeId: resourceId,
        });
    });
    return {
        cost: actualCost,
        packageId: id,
        rewards: state.grantRewards.rewards,
    };
};
var mapDispatch = function (dispatch) { return ({
    onCollect: function () { return dispatch(actionGrantRewardsCollect()); },
    onCollectAndRepeat: function (id, cost) {
        dispatch(actionGrantRewardsCollect());
        dispatch(actionStoreBuyPackage(id, 1, cost));
    },
}); };
export var DialogCollectRewardStore = connect(mapState, mapDispatch)(_DialogCollectRewardStore);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/DialogCollectRewardStore.tsx
// module id = 2927
// module chunks = 3